import { AxiosError } from 'axios';

/**
 * The human-readable explanation the API attached to a failure (§13's `detail`).
 *
 * ⚠️ Reaching for this before a local fallback is the point.
 *
 * Every handler in this API answers a business failure with a specific sentence — «لا يمكن اعتماد
 * ملفك بنفسك», «سبق رفض هذا الملف», «المهمة ملغاة». The panel was throwing all of them away and
 * substituting one generic line per status code, which is a real loss: an operator told "you do not
 * have permission" goes looking for a role change, while the same operator told "you cannot review
 * your own profile" understands immediately that they clicked the wrong row.
 *
 * Found by refusing a volunteer in the browser and reading the server log next to the screen.
 */
export function problemDetail(error: unknown): string | null {
  if (!(error instanceof AxiosError)) {
    return null;
  }

  const data = error.response?.data as { detail?: unknown } | undefined;

  // Only a non-empty string. A ValidationProblemDetails carries `errors` instead and no useful
  // `detail`, and rendering `[object Object]` into a control room would be worse than the fallback.
  return typeof data?.detail === 'string' && data.detail.trim().length > 0 ? data.detail : null;
}
